import Chart from "chart.js/auto";

let traderChart = [];

const radarChart = (canvasId) => {
  const canvasElem = document.getElementById(canvasId);

  const windowMedia = window.matchMedia("(min-width: 1024px)");
  let pointSpacing = 10;
  let borderSpacing = [2, 2];
  let pointFontsize = 11;

  if (windowMedia.matches) {
    pointSpacing = 40;
    borderSpacing = [4, 4];
    pointFontsize = 12;
  }

  const configData = JSON.parse(canvasElem.dataset.config);
  const colorsData = JSON.parse(canvasElem.dataset.colors);
  const labelsData = JSON.parse(canvasElem.dataset.labels);
  const traderData = JSON.parse(canvasElem.dataset.trader);
  const traderCompareAttr = canvasElem.dataset.traderCompare;
  let dataTraderCompare;
  let dataTradersSets;

  const dataTrader = {
    label: traderData.label,
    data: traderData.data,
    backgroundColor: colorsData.trader,
    fill: true,
    pointStyle: false,
    order: 2,
  };

  let legendDisplay = false;
  if (configData.legend) {
    legendDisplay = true;
  }

  if (traderCompareAttr) {
    const traderCompareData = JSON.parse(traderCompareAttr);
    dataTraderCompare = {
      label: traderCompareData.label,
      data: traderCompareData.data,
      backgroundColor: colorsData.trader_compare + "60",
      fill: true,
      pointStyle: false,
      order: 1,
    };

    dataTradersSets = [dataTrader, dataTraderCompare];
  } else {
    dataTradersSets = [dataTrader];
  }

  const data = {
    labels: labelsData,
    datasets: dataTradersSets,
  };

  const config = {
    type: "radar",
    data: data,
    options: {
      animations: {
        tension: {
          duration: 4000,
          easing: configData.animation,
          from: 1,
          to: 0,
        },
      },
      devicePixelRatio: 2,
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: legendDisplay,
          align: "start",
          fullSize: true,
          position: "top",
          labels: {
            color: colorsData.label,
            usePointStyle: true,
            pointStyle: "circle",
            padding: 24,
          },
          onHover: function (e, legendItem, legend) {
            e.native.target.style.cursor = 'pointer';
          },
          onLeave: function (e, legendItem, legend) {
            e.native.target.style.cursor = 'default';
          }
        },
      },
      scales: {
        r: {
          min: 0,
          max: configData.max,
          beginAtZero: true,
          grid: {
            color: colorsData.line,
            z: 1,
          },
          angleLines: {
            color: colorsData.line,
            borderDash: borderSpacing,
            borderDashOffset: 1,
          },
          border: {
            dash: borderSpacing,
            dashOffset: 1,
          },
          ticks: {
            display: false,
            maxTicksLimit: 2,
          },
          pointLabels: {
            color: colorsData.label,
            padding: pointSpacing,
            font: {
              size: pointFontsize,
              family: configData.family,
            },
          },
        },
      },
      elements: {
        line: {
          borderWidth: 1,
        },
      },
    },
  };

  // traderChart = new Chart(canvasElem, config);
  traderChart.push(new Chart(canvasElem, config));
};

const radarInit = () => {
  const radarItems = document.querySelectorAll(".js-rating-chart");

  for (let i = 0; i < radarItems.length; i++) {
    const canvasId = radarItems[i].getAttribute("id");
    radarChart(canvasId);
  }
};

document.addEventListener("DOMContentLoaded", function () {
  document.fonts.ready.then(function() {
		radarInit();
	}).catch(function(error) {
		console.error('Font loading failed:', error);
	});
});

window.addEventListener(
  "resize",
  function (event) {
    for (let i = 0; i < traderChart.length; i++) {
      traderChart[i].destroy();
    }
    radarInit();
  },
  true
);
